import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'rmt-list-card',
  templateUrl: 'rmt-list-card.html'
})
export class RmtListCardComponent {
  @Input() title;
  @Input() text;
  @Input() subText;
  @Input() icon;
  @Input() image;
  @Input() imageAlt;
  @Input() imageLoading;
  @Input() initials;
  @Input() color;
  @Input() colorText;
  @Input() selected;
  @Input() buttons;
  @Input() locationIndex;
  @Input() arrow: boolean = true;
  @Input() customId:string = '';
  @Output() clickButton = new EventEmitter<number>();
  @ViewChild('img', { read: ElementRef }) img;
  @ViewChild('loading', { read: ElementRef }) loading;
  
  countryFlag: string;

  constructor() {    
  }

  ngOnInit() {
    if(this.icon && this.icon.indexOf('custom-icon-country') == 0) {
      const country = this.icon.split("-").pop()
      this.countryFlag = 'assets/countryFlagSvg/' + country.toUpperCase() + '.svg';
    }
  }

  ngAfterViewInit() {
    if (this.img)
      this.img.nativeElement.onload = () => {
        if (this.loading)
          this.loading.nativeElement.style.opacity = '0.0';
      };
  }

  processClickButton(ev) {
    this.clickButton.emit(ev);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-list-card/rmt-list-card.ts